module.exports = __webpack_public_path__ + "img/lightening-white.5379690b.svg";